import Component from '@bythepixel/component-loader';
import runInView from '@bythepixel/run-in-view';

export default class TrailerAnimation extends Component {
  static selector = '[comp-trailer-animation]'

  constructor(animatedEl) {
    super(animatedEl);
    runInView(this.$container, () => this.animate(), 1);
    this.src = this.$container.dataset.trailerImage;
    this.skipAnimation = new URLSearchParams(window.location.search).get('skipAni') === 'true';
  }

  async animate() {
    this.boundOnAnimationEnd = (e) => this.onAnimationEnd(e);
    this.$container.addEventListener('animationend', this.boundOnAnimationEnd);
    if (this.skipAnimation) {
      this.$container.style.animationDuration = '0s';
      removeSkipAnimationParam();
    }
    await loadImage(this.src);
    this.$container.src = this.src;
    this.$container.style.opacity = 1;
    this.start();
  }

  onAnimationEnd(e) {
    if (e.target !== this.$container) return;
    this.$container.removeEventListener('animationend', this.boundOnAnimationEnd);
    this.$container.classList.remove('trailer-animation');
  }

  start() {
    this.$container.classList.add('trailer-animation');
  }
}

// This aactually removes all query params
function removeSkipAnimationParam() {
  window.history.pushState({}, document.title, window.location.pathname);
}

async function loadImage(src) {
  const image = new Image();
  const loadImagePromise = new Promise((resolve, reject) => {
    image.addEventListener('load', () => {
      resolve();
    });
    image.addEventListener('error', () => {
      reject();
    });
  });
  image.src = src;
  return loadImagePromise;
}
